import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useLocation } from "react-router-dom";
import { Page } from "../Page";
import { ColumnLayout } from "@/components/Layout/ColumnLayout";
import { MerchandiseLedgerContent } from "@/components/Reports/MerchandiseLedger/MerchandiseLedgerContent";
import { parseMerchandiseLedgerParams } from "@/components/Reports/MerchandiseLedger/merchandiseLedgerRoute";

export const MerchandiseLedgerReportPage = () => {
    const { search } = useLocation();
    // ?catalogItem=<id> → inventory mode (scoped to one variant); ?product=<id> → merchandise mode.
    const { catalogItemId, productId: initialProductId } = parseMerchandiseLedgerParams(search);

    return (
        <Page title="Merchandise Ledger">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item>Merchandise Ledger</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    {/* The route matches with or without a search string, so navigating between two ledger
                        deep links never remounts. Key on the query string to force a fresh instance,
                        otherwise product A's filter state leaks under product B's URL. */}
                    <MerchandiseLedgerContent
                        key={search}
                        initialProductId={initialProductId}
                        catalogItemId={catalogItemId}
                    />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
